/**
 * 어플리케이션 설정 API
 * 비밀번호
 */
import { api } from "@/redworks/api/index";

const SETTINGS_PATH = {
  APP_INFO: "/v1/settings/appInfo", // 어플리케이션 기본 정보 API
  AUTH_POLICY: "/v1/settings/authPolicy", // 패스워드 변경 정책 API
};
const SETTINGS_RST_CD = {
  SUCCESS: 200,  // 성공
};

// 어플리케이션 기본 정보 조회 API
function $getAppInfo() {
  return api.get(SETTINGS_PATH.APP_INFO);
}

// 어플리케이션 기본 정보 수정 API
function $updateAppInfo(params, file) {
  let formData = new FormData();
  if(file != undefined) formData.append("file", file[0]);
  formData.append('data', JSON.stringify(params));
  return api.put(SETTINGS_PATH.APP_INFO, formData, {
    headers: { "Content-Type": "multipart/form-data"}
  });
}

// 인증 정책 조회 API
function $getAuthPolicy() {
  return api.get(SETTINGS_PATH.AUTH_POLICY);
}

// 인증 정책 수정 API
function $updateAuthPolicy(param) {
  return api.put(SETTINGS_PATH.AUTH_POLICY, param);
}

export {
  SETTINGS_RST_CD,
  $getAppInfo,
  $getAuthPolicy,
  $updateAuthPolicy,
  $updateAppInfo,
};
 